// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"loginDarkColor": "#2c3342",
	"darkBtnHoverColor": "#f4f4f8",
	"greyHoverColor": "#dee1e7",
	"defaultBackgroundColor": "#fff"
};
module.exports = exports;
